export default __webpack_public_path__ + "static/media/640_dummy2016-pragentur01-de-mobile.5de54b77.png";